export default function TopStyle() {
    return (
        <svg
          className='absolute top-0 left-0 z-0 hidden w-full lg:block'
          viewBox='0 0 1509 80'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g opacity='0.2'>
            <mask
              id='mask0_5118_1448'
              style={{ maskType: "alpha" }}
              maskUnits='userSpaceOnUse'
              x='0'
              y='0'
              width='1509'
              height='80'
            >
              <rect width='3' height='80' fill='#D9D9D9' />
              <rect x='6' width='3' height='42' fill='#D9D9D9' />
              <rect x='12' width='3' height='51' fill='#D9D9D9' />
              <rect x='18' width='3' height='80' fill='#D9D9D9' />
              <rect x='24' width='3' height='35' fill='#D9D9D9' />
              <rect x='30' width='3' height='63' fill='#D9D9D9' />
              <rect x='36' width='3' height='47' fill='#D9D9D9' />
              <rect x='42' width='3' height='20' fill='#D9D9D9' />
              <rect x='48' width='3' height='28' fill='#D9D9D9' />
              <rect x='54' width='3' height='71' fill='#D9D9D9' />
              <rect x='60' width='3' height='58' fill='#D9D9D9' />
              <rect x='66' width='3' height='35' fill='#D9D9D9' />
              <rect x='72' width='3' height='80' fill='#D9D9D9' />
              <rect x='78' width='3' height='42' fill='#D9D9D9' />
              <rect x='84' width='3' height='51' fill='#D9D9D9' />
              <rect x='90' width='3' height='80' fill='#D9D9D9' />
              <rect x='96' width='3' height='35' fill='#D9D9D9' />
              <rect x='102' width='3' height='63' fill='#D9D9D9' />
              <rect x='108' width='3' height='47' fill='#D9D9D9' />
              <rect x='114' width='3' height='20' fill='#D9D9D9' />
              <rect x='120' width='3' height='28' fill='#D9D9D9' />
              <rect x='126' width='3' height='71' fill='#D9D9D9' />
              <rect x='132' width='3' height='58' fill='#D9D9D9' />
              <rect x='138' width='3' height='35' fill='#D9D9D9' />
              <rect x='144' width='3' height='80' fill='#D9D9D9' />
              <rect x='150' width='3' height='42' fill='#D9D9D9' />
              <rect x='156' width='3' height='51' fill='#D9D9D9' />
              <rect x='162' width='3' height='80' fill='#D9D9D9' />
              <rect x='168' width='3' height='35' fill='#D9D9D9' />
              <rect x='174' width='3' height='63' fill='#D9D9D9' />
              <rect x='180' width='3' height='47' fill='#D9D9D9' />
              <rect x='186' width='3' height='20' fill='#D9D9D9' />
              <rect x='192' width='3' height='28' fill='#D9D9D9' />
              <rect x='198' width='3' height='71' fill='#D9D9D9' />
              <rect x='204' width='3' height='58' fill='#D9D9D9' />
              <rect x='210' width='3' height='35' fill='#D9D9D9' />
              <rect x='216' width='3' height='80' fill='#D9D9D9' />
              <rect x='222' width='3' height='42' fill='#D9D9D9' />
              <rect x='228' width='3' height='51' fill='#D9D9D9' />
              <rect x='234' width='3' height='80' fill='#D9D9D9' />
              <rect x='240' width='3' height='35' fill='#D9D9D9' />
              <rect x='246' width='3' height='63' fill='#D9D9D9' />
              <rect x='252' width='3' height='47' fill='#D9D9D9' />
              <rect x='258' width='3' height='20' fill='#D9D9D9' />
              <rect x='264' width='3' height='28' fill='#D9D9D9' />
              <rect x='270' width='3' height='71' fill='#D9D9D9' />
              <rect x='276' width='3' height='58' fill='#D9D9D9' />
              <rect x='282' width='3' height='35' fill='#D9D9D9' />
              <rect x='288' width='3' height='80' fill='#D9D9D9' />
              <rect x='294' width='3' height='42' fill='#D9D9D9' />
              <rect x='300' width='3' height='51' fill='#D9D9D9' />
              <rect x='306' width='3' height='80' fill='#D9D9D9' />
              <rect x='312' width='3' height='35' fill='#D9D9D9' />
              <rect x='318' width='3' height='63' fill='#D9D9D9' />
              <rect x='324' width='3' height='47' fill='#D9D9D9' />
              <rect x='330' width='3' height='20' fill='#D9D9D9' />
              <rect x='336' width='3' height='28' fill='#D9D9D9' />
              <rect x='342' width='3' height='71' fill='#D9D9D9' />
              <rect x='348' width='3' height='58' fill='#D9D9D9' />
              <rect x='354' width='3' height='35' fill='#D9D9D9' />
              <rect x='360' width='3' height='80' fill='#D9D9D9' />
              <rect x='366' width='3' height='42' fill='#D9D9D9' />
              <rect x='372' width='3' height='51' fill='#D9D9D9' />
              <rect x='378' width='3' height='80' fill='#D9D9D9' />
              <rect x='384' width='3' height='35' fill='#D9D9D9' />
              <rect x='390' width='3' height='63' fill='#D9D9D9' />
              <rect x='396' width='3' height='47' fill='#D9D9D9' />
              <rect x='402' width='3' height='20' fill='#D9D9D9' />
              <rect x='408' width='3' height='28' fill='#D9D9D9' />
              <rect x='414' width='3' height='71' fill='#D9D9D9' />
              <rect x='420' width='3' height='58' fill='#D9D9D9' />
              <rect x='426' width='3' height='35' fill='#D9D9D9' />
              <rect x='432' width='3' height='80' fill='#D9D9D9' />
              <rect x='438' width='3' height='42' fill='#D9D9D9' />
              <rect x='444' width='3' height='51' fill='#D9D9D9' />
              <rect x='450' width='3' height='80' fill='#D9D9D9' />
              <rect x='456' width='3' height='35' fill='#D9D9D9' />
              <rect x='462' width='3' height='63' fill='#D9D9D9' />
              <rect x='468' width='3' height='47' fill='#D9D9D9' />
              <rect x='474' width='3' height='20' fill='#D9D9D9' />
              <rect x='480' width='3' height='28' fill='#D9D9D9' />
              <rect x='486' width='3' height='71' fill='#D9D9D9' />
              <rect x='492' width='3' height='58' fill='#D9D9D9' />
              <rect x='498' width='3' height='35' fill='#D9D9D9' />
              <rect x='504' width='3' height='80' fill='#D9D9D9' />
              <rect x='510' width='3' height='42' fill='#D9D9D9' />
              <rect x='516' width='3' height='51' fill='#D9D9D9' />
              <rect x='522' width='3' height='80' fill='#D9D9D9' />
              <rect x='528' width='3' height='35' fill='#D9D9D9' />
              <rect x='534' width='3' height='63' fill='#D9D9D9' />
              <rect x='540' width='3' height='47' fill='#D9D9D9' />
              <rect x='546' width='3' height='20' fill='#D9D9D9' />
              <rect x='552' width='3' height='28' fill='#D9D9D9' />
              <rect x='558' width='3' height='71' fill='#D9D9D9' />
              <rect x='564' width='3' height='58' fill='#D9D9D9' />
              <rect x='570' width='3' height='35' fill='#D9D9D9' />
              <rect x='576' width='3' height='80' fill='#D9D9D9' />
              <rect x='582' width='3' height='42' fill='#D9D9D9' />
              <rect x='588' width='3' height='51' fill='#D9D9D9' />
              <rect x='594' width='3' height='80' fill='#D9D9D9' />
              <rect x='600' width='3' height='35' fill='#D9D9D9' />
              <rect x='606' width='3' height='63' fill='#D9D9D9' />
              <rect x='612' width='3' height='47' fill='#D9D9D9' />
              <rect x='618' width='3' height='20' fill='#D9D9D9' />
              <rect x='624' width='3' height='28' fill='#D9D9D9' />
              <rect x='630' width='3' height='71' fill='#D9D9D9' />
              <rect x='636' width='3' height='58' fill='#D9D9D9' />
              <rect x='642' width='3' height='35' fill='#D9D9D9' />
              <rect x='648' width='3' height='80' fill='#D9D9D9' />
              <rect x='654' width='3' height='42' fill='#D9D9D9' />
              <rect x='660' width='3' height='51' fill='#D9D9D9' />
              <rect x='666' width='3' height='80' fill='#D9D9D9' />
              <rect x='672' width='3' height='35' fill='#D9D9D9' />
              <rect x='678' width='3' height='63' fill='#D9D9D9' />
              <rect x='684' width='3' height='47' fill='#D9D9D9' />
              <rect x='690' width='3' height='20' fill='#D9D9D9' />
              <rect x='696' width='3' height='28' fill='#D9D9D9' />
              <rect x='702' width='3' height='71' fill='#D9D9D9' />
              <rect x='708' width='3' height='58' fill='#D9D9D9' />
              <rect x='714' width='3' height='35' fill='#D9D9D9' />
              <rect x='720' width='3' height='80' fill='#D9D9D9' />
              <rect x='726' width='3' height='42' fill='#D9D9D9' />
              <rect x='732' width='3' height='51' fill='#D9D9D9' />
              <rect x='738' width='3' height='80' fill='#D9D9D9' />
              <rect x='744' width='3' height='35' fill='#D9D9D9' />
              <rect x='750' width='3' height='63' fill='#D9D9D9' />
              <rect x='756' width='3' height='47' fill='#D9D9D9' />
              <rect x='762' width='3' height='20' fill='#D9D9D9' />
              <rect x='768' width='3' height='28' fill='#D9D9D9' />
              <rect x='774' width='3' height='71' fill='#D9D9D9' />
              <rect x='780' width='3' height='58' fill='#D9D9D9' />
              <rect x='786' width='3' height='35' fill='#D9D9D9' />
              <rect x='792' width='3' height='80' fill='#D9D9D9' />
              <rect x='798' width='3' height='42' fill='#D9D9D9' />
              <rect x='804' width='3' height='51' fill='#D9D9D9' />
              <rect x='810' width='3' height='80' fill='#D9D9D9' />
              <rect x='816' width='3' height='35' fill='#D9D9D9' />
              <rect x='822' width='3' height='63' fill='#D9D9D9' />
              <rect x='828' width='3' height='47' fill='#D9D9D9' />
              <rect x='834' width='3' height='20' fill='#D9D9D9' />
              <rect x='840' width='3' height='28' fill='#D9D9D9' />
              <rect x='846' width='3' height='71' fill='#D9D9D9' />
              <rect x='852' width='3' height='58' fill='#D9D9D9' />
              <rect x='858' width='3' height='35' fill='#D9D9D9' />
              <rect x='864' width='3' height='80' fill='#D9D9D9' />
              <rect x='870' width='3' height='42' fill='#D9D9D9' />
              <rect x='876' width='3' height='51' fill='#D9D9D9' />
              <rect x='882' width='3' height='80' fill='#D9D9D9' />
              <rect x='888' width='3' height='35' fill='#D9D9D9' />
              <rect x='894' width='3' height='63' fill='#D9D9D9' />
              <rect x='900' width='3' height='47' fill='#D9D9D9' />
              <rect x='906' width='3' height='20' fill='#D9D9D9' />
              <rect x='912' width='3' height='28' fill='#D9D9D9' />
              <rect x='918' width='3' height='71' fill='#D9D9D9' />
              <rect x='924' width='3' height='58' fill='#D9D9D9' />
              <rect x='930' width='3' height='35' fill='#D9D9D9' />
              <rect x='936' width='3' height='80' fill='#D9D9D9' />
              <rect x='942' width='3' height='42' fill='#D9D9D9' />
              <rect x='948' width='3' height='51' fill='#D9D9D9' />
              <rect x='954' width='3' height='80' fill='#D9D9D9' />
              <rect x='960' width='3' height='35' fill='#D9D9D9' />
              <rect x='966' width='3' height='63' fill='#D9D9D9' />
              <rect x='972' width='3' height='47' fill='#D9D9D9' />
              <rect x='978' width='3' height='20' fill='#D9D9D9' />
              <rect x='984' width='3' height='28' fill='#D9D9D9' />
              <rect x='990' width='3' height='71' fill='#D9D9D9' />
              <rect x='996' width='3' height='58' fill='#D9D9D9' />
              <rect x='1002' width='3' height='35' fill='#D9D9D9' />
              <rect x='1008' width='3' height='80' fill='#D9D9D9' />
              <rect x='1014' width='3' height='42' fill='#D9D9D9' />
              <rect x='1020' width='3' height='51' fill='#D9D9D9' />
              <rect x='1026' width='3' height='80' fill='#D9D9D9' />
              <rect x='1032' width='3' height='35' fill='#D9D9D9' />
              <rect x='1038' width='3' height='63' fill='#D9D9D9' />
              <rect x='1044' width='3' height='47' fill='#D9D9D9' />
              <rect x='1050' width='3' height='20' fill='#D9D9D9' />
              <rect x='1056' width='3' height='28' fill='#D9D9D9' />
              <rect x='1062' width='3' height='71' fill='#D9D9D9' />
              <rect x='1068' width='3' height='58' fill='#D9D9D9' />
              <rect x='1074' width='3' height='35' fill='#D9D9D9' />
              <rect x='1080' width='3' height='80' fill='#D9D9D9' />
              <rect x='1086' width='3' height='42' fill='#D9D9D9' />
              <rect x='1092' width='3' height='51' fill='#D9D9D9' />
              <rect x='1098' width='3' height='80' fill='#D9D9D9' />
              <rect x='1104' width='3' height='35' fill='#D9D9D9' />
              <rect x='1110' width='3' height='63' fill='#D9D9D9' />
              <rect x='1116' width='3' height='47' fill='#D9D9D9' />
              <rect x='1122' width='3' height='20' fill='#D9D9D9' />
              <rect x='1128' width='3' height='28' fill='#D9D9D9' />
              <rect x='1134' width='3' height='71' fill='#D9D9D9' />
              <rect x='1140' width='3' height='58' fill='#D9D9D9' />
              <rect x='1146' width='3' height='35' fill='#D9D9D9' />
              <rect x='1152' width='3' height='80' fill='#D9D9D9' />
              <rect x='1158' width='3' height='42' fill='#D9D9D9' />
              <rect x='1164' width='3' height='51' fill='#D9D9D9' />
              <rect x='1170' width='3' height='80' fill='#D9D9D9' />
              <rect x='1176' width='3' height='35' fill='#D9D9D9' />
              <rect x='1182' width='3' height='63' fill='#D9D9D9' />
              <rect x='1188' width='3' height='47' fill='#D9D9D9' />
              <rect x='1194' width='3' height='20' fill='#D9D9D9' />
              <rect x='1200' width='3' height='28' fill='#D9D9D9' />
              <rect x='1206' width='3' height='71' fill='#D9D9D9' />
              <rect x='1212' width='3' height='58' fill='#D9D9D9' />
              <rect x='1218' width='3' height='35' fill='#D9D9D9' />
              <rect x='1224' width='3' height='80' fill='#D9D9D9' />
              <rect x='1230' width='3' height='42' fill='#D9D9D9' />
              <rect x='1236' width='3' height='51' fill='#D9D9D9' />
              <rect x='1242' width='3' height='80' fill='#D9D9D9' />
              <rect x='1248' width='3' height='35' fill='#D9D9D9' />
              <rect x='1254' width='3' height='63' fill='#D9D9D9' />
              <rect x='1260' width='3' height='47' fill='#D9D9D9' />
              <rect x='1266' width='3' height='20' fill='#D9D9D9' />
              <rect x='1272' width='3' height='28' fill='#D9D9D9' />
              <rect x='1278' width='3' height='71' fill='#D9D9D9' />
              <rect x='1284' width='3' height='58' fill='#D9D9D9' />
              <rect x='1290' width='3' height='35' fill='#D9D9D9' />
              <rect x='1296' width='3' height='80' fill='#D9D9D9' />
              <rect x='1302' width='3' height='42' fill='#D9D9D9' />
              <rect x='1308' width='3' height='51' fill='#D9D9D9' />
              <rect x='1314' width='3' height='80' fill='#D9D9D9' />
              <rect x='1320' width='3' height='35' fill='#D9D9D9' />
              <rect x='1326' width='3' height='63' fill='#D9D9D9' />
              <rect x='1332' width='3' height='47' fill='#D9D9D9' />
              <rect x='1338' width='3' height='20' fill='#D9D9D9' />
              <rect x='1344' width='3' height='28' fill='#D9D9D9' />
              <rect x='1350' width='3' height='71' fill='#D9D9D9' />
              <rect x='1356' width='3' height='58' fill='#D9D9D9' />
              <rect x='1362' width='3' height='35' fill='#D9D9D9' />
              <rect x='1368' width='3' height='80' fill='#D9D9D9' />
              <rect x='1374' width='3' height='42' fill='#D9D9D9' />
              <rect x='1380' width='3' height='51' fill='#D9D9D9' />
              <rect x='1386' width='3' height='80' fill='#D9D9D9' />
              <rect x='1392' width='3' height='35' fill='#D9D9D9' />
              <rect x='1398' width='3' height='63' fill='#D9D9D9' />
              <rect x='1404' width='3' height='47' fill='#D9D9D9' />
              <rect x='1410' width='3' height='20' fill='#D9D9D9' />
              <rect x='1416' width='3' height='28' fill='#D9D9D9' />
              <rect x='1422' width='3' height='71' fill='#D9D9D9' />
              <rect x='1428' width='3' height='58' fill='#D9D9D9' />
              <rect x='1434' width='3' height='35' fill='#D9D9D9' />
              <rect x='1440' width='3' height='80' fill='#D9D9D9' />
              <rect x='1446' width='3' height='42' fill='#D9D9D9' />
              <rect x='1452' width='3' height='51' fill='#D9D9D9' />
              <rect x='1458' width='3' height='80' fill='#D9D9D9' />
              <rect x='1464' width='3' height='35' fill='#D9D9D9' />
              <rect x='1470' width='3' height='63' fill='#D9D9D9' />
              <rect x='1476' width='3' height='47' fill='#D9D9D9' />
              <rect x='1482' width='3' height='20' fill='#D9D9D9' />
              <rect x='1488' width='3' height='28' fill='#D9D9D9' />
              <rect x='1494' width='3' height='71' fill='#D9D9D9' />
              <rect x='1500' width='3' height='58' fill='#D9D9D9' />
              <rect x='1506' width='3' height='35' fill='#D9D9D9' />
            </mask>
            <g mask='url(#mask0_5118_1448)'>
              <rect
                width='1509'
                height='80'
                fill='url(#paint0_linear_5118_1448)'
              />
            </g>
          </g>
          <defs>
            <linearGradient
              id='paint0_linear_5118_1448'
              x1='92.9842'
              y1='66.9093'
              x2='1429.86'
              y2='-272.093'
              gradientUnits='userSpaceOnUse'
            >
              <stop stopColor='#FFD338' />
              <stop offset='1' stopColor='#CD4F4F' />
            </linearGradient>
          </defs>
        </svg>
    )
}